export default __webpack_public_path__ + "static/media/verification_sent.29ae977a.png";